import { AuthState } from "@okta/okta-auth-js";
import { Server } from "../../Shared/Util/Server";
import { formatRequestParams } from "../../Responses/duck/RequestFormatting";
import { IPublishedRequestParams } from "../../Responses/duck/Operations";

export function fetchDeletedResponsesFacet(auth: AuthState, propertyName: string): Promise<any> {
  return Server.get<any>(`/response/deletedresponse?pageNumber=1&resultsPerPage=1&orderBy=dateDeleted desc&facet=${propertyName},count:200`, auth);
}

export interface IDeletedRequestParams {
  pageNumber: number;
  pageSize: number;
  orderBy: string;
  filter?: { filters: any[] };
}

export function fetchDeletedResponses(auth: AuthState, requestParams: IDeletedRequestParams): Promise<Api.IDeletedResponseListResponse | null> {
  const { pageNumber, pageSize, orderBy, filter } = requestParams;

  let url = `/response/deletedresponse?pageNumber=${pageNumber}&resultsPerPage=${pageSize}&orderBy=${encodeURIComponent(orderBy)}`;

  if (filter && filter.filters && filter.filters.length > 0) {
    const formatted = formatRequestParams({ pageNumber, pageSize, skip: 0, filter, orderBy } as IPublishedRequestParams);
    if (formatted.filter.filters) {
      url += `&filter=${formatted.filter.filters}`;
    }
  }

  return Server.get<Api.IDeletedResponseListResponse>(url, auth);
}
